import Input from 'components/forms/Input'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import Textarea from '../../../components/forms/Textarea'
import { SANDRE } from '../../../referencial/constants/ReferencialConstants'
import DtoSurvey from '../../dto/DtoSurvey'
import Checkbox from 'components/forms/Checkbox'
import { SURVEY_TYPES } from 'agriAdministration/constants/AgriConstants'
import { Grid } from '@mui/material'
import useSandreList from 'utils/customHook/useSandreList'

const FormSurvey = ({
    survey = {},
    onChangeSurvey = () => { },
    readMode = false,
}) => {
    const {
        contributors,
        cmsEvents,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        cmsEvents: store.EventsReducer.cmsEvents,
    }), shallowEqual)

    const { year, statusCode, startDate, comment, endDate, adminEndDate, cmsId, name, contributorId,
        ddtLimitDate, agencyLimitDate, surveyType, authorizationDate, exportNotifications,
    } = survey
    const mode = { disabled: readMode }

    const statusList = useSandreList(SANDRE.CMS_STATUT)

    return (
        <Grid container spacing={1} className='padding-1'>
            <Grid size={3}>
                <Input
                    title={i18n.name}
                    value={name}
                    onChange={value => onChangeSurvey({ name: value })}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <NumberField
                    title={i18n.year}
                    value={year}
                    onChange={value => onChangeSurvey({ year: value })}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    value={startDate}
                    label={i18n.startDate}
                    onChange={v => onChangeSurvey({ startDate: v })}
                    max={endDate}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    value={endDate}
                    label={i18n.endDate}
                    onChange={v => onChangeSurvey({ endDate: v })}
                    min={startDate}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <Select
                    label={i18n.status}
                    options={statusList}
                    value={statusCode}
                    integerValue
                    keyValue='code'
                    onChange={value => onChangeSurvey({ statusCode: value })}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <Select
                    label={i18n.type}
                    options={[{
                        value: SURVEY_TYPES.ANNUAL,
                        label: i18n.annual,
                    }, {
                        value: SURVEY_TYPES.INTERMEDIATE,
                        label: i18n.intermediate,
                    }]}
                    value={surveyType}
                    integerValue
                    onChange={value => onChangeSurvey({ surveyType: value, exportNotifications: value === SURVEY_TYPES.INTERMEDIATE ? false : exportNotifications })}
                    noNullValue
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    value={adminEndDate}
                    label={i18n.adminEndDate}
                    onChange={v => onChangeSurvey({ adminEndDate: v })}
                    min={startDate}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    value={authorizationDate}
                    label={i18n.authorisationDate}
                    onChange={v => onChangeSurvey({ authorizationDate: v })}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <Select
                    label='CMS Logos'
                    value={cmsId}
                    onChange={value => onChangeSurvey({ cmsId: value })}
                    options={cmsEvents}
                    keyLabel='title'
                    keyValue='id'
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <Select
                    label={i18n.organism}
                    options={contributors}
                    value={contributorId}
                    integerValue
                    keyValue='code'
                    onChange={value => onChangeSurvey({ contributorId: value })}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    value={ddtLimitDate}
                    label={i18n.ddtLimitDate}
                    onChange={v => onChangeSurvey({ ddtLimitDate: v })}
                    {...mode}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    value={agencyLimitDate}
                    label={i18n.agencyLimitDate}
                    onChange={v => onChangeSurvey({ agencyLimitDate: v })}
                    {...mode}
                />
            </Grid>
            <Grid>
                <Checkbox
                    col
                    id='exportNotifications'
                    label={i18n.authorizedNotifsExport}
                    checked={exportNotifications || false}
                    onChange={v => onChangeSurvey({ exportNotifications: v })}
                    {...mode}
                    disabled={readMode || surveyType === SURVEY_TYPES.INTERMEDIATE}
                    tooltip={surveyType === SURVEY_TYPES.INTERMEDIATE ? i18n.notificationsOnlyForAnnualSurvey : null}
                />
            </Grid>
            <Grid size={12}>
                <Textarea
                    title={i18n.comment}
                    value={comment}
                    onChange={value => onChangeSurvey({ comment: value })}
                    {...mode}
                />
            </Grid>
        </Grid>
    )
}

FormSurvey.propTypes = {
    survey: PropTypes.instanceOf(DtoSurvey),
    readMode: PropTypes.bool,
    onChangeSurvey: PropTypes.func,
}

export default FormSurvey